export default dataNetworkTest = {
    results: {},
    loading: {},
    lastBackendTestRun: {},

    frontendResults: {},
    frontendLoading: {},
    lastFrontendTestRun: {},

    getServiceKey(service) {
        return `${service.name}-${service.url}`;
    },

    getResult(service, data) {
        let message = "Failed";

        if (data.body === 'Validated by no-cors') {
            message = "Partial Success";
        } else if (service.name === 'DAX Core Streaming' && data.status === 415) {
            message = "Success";
        } else if (data.status === 200) {
            message = "Success";
        }

        return {
            ...service,
            message,
            status: data.status,
            body: data.body,
        }
    },

    async runBackendTests() {
        this.lastBackendTestRun[Alpine.store('drc').selectedCountryName] = new Date().toLocaleString();

        Alpine.store('drc').services.forEach(service => {
            const serviceKey = this.getServiceKey(service);

            this.results[serviceKey] = '';
            this.loading[serviceKey] = true;
        });

        await Promise.all(Alpine.store('drc').services.map(async (service) => {
            const serviceKey = this.getServiceKey(service);

            try {
                const resp = await fetch(`/api/health-check?url=${encodeURIComponent(service.url)}`);
                const data = await resp.json();
                this.results[serviceKey] = this.getResult(service, data);
            } catch (error) {
                this.results[serviceKey] = this.getResult(service, {
                    body: `Error: ${error.message}`,
                });
            } finally {
                this.loading[serviceKey] = false;
            }
        }));
    },

    async runFrontendTests() {
        this.lastFrontendTestRun[Alpine.store('drc').selectedCountryName] = new Date().toLocaleString();

        Alpine.store('drc').services.forEach(service => {
            const serviceKey = this.getServiceKey(service);

            this.frontendResults[serviceKey] = '';
            this.frontendLoading[serviceKey] = true;
        });

        await Promise.all(Alpine.store('drc').services.map(async (service) => {
            const serviceKey = this.getServiceKey(service);

            try {
                const respFromDirectUiFetch = await fetch(service.url);
                if (!respFromDirectUiFetch.ok) {
                    throw new Error(`HTTP error! status: ${respFromDirectUiFetch.status}`);
                }
                const dataFromDirectUiFetch = await respFromDirectUiFetch.text();
                this.frontendResults[serviceKey] = this.getResult(service, {
                    status: respFromDirectUiFetch.status,
                    body: dataFromDirectUiFetch,
                });
            } catch (error) {
                try {
                    await fetch(service.url, { mode: 'no-cors' });
                    this.frontendResults[serviceKey] = this.getResult(service, {
                        body: 'Validated by no-cors',
                    });
                } catch (error) {
                    this.frontendResults[serviceKey] = this.getResult(service, {
                        body: `Error: ${error.message}`,
                    });
                }
            } finally {
                this.frontendLoading[serviceKey] = false;
            }
        }));
    },
};